<template>
  <div ref="wrap"></div>
</template>

<script>
export default {
  name: 'WistiaPlayer',
  props: {
    mediaId: { 
      type: String, 
      required: true 
    },
    aspect: { 
      type: [Number, String], 
      default: '16/9'
    }
  },
  mounted() {
    // 1) create the <wistia-player> element
    const playerEl = document.createElement('wistia-player');
    playerEl.setAttribute('media-id', this.mediaId);
    playerEl.setAttribute('aspect', this.aspect);
    this.$refs.wrap.appendChild(playerEl);

    // 2) load the per‐video embed script
    const embedScript = document.createElement('script');
    embedScript.src = `https://fast.wistia.com/embed/${this.mediaId}.js`;
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
  }
}
</script>